// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn-width {\n    width: 1% !important;\n}\n.text-block {\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    text-indent: -4px;\n    width: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
